import SearchName from './SearchName';

export default SearchName;
